export default {
	wrapper: {
		left: 0,
		right: 0,
		overflow: 'hidden'
	},
	video: {
		'object-fit': 'cover',
		width: '100%',
		height: '100%',

		/* Flip horizontally */
		'-webkit-transform': 'scaleX(-1)',
		transform: 'scaleX(-1)'
	}
}



// WEBPACK FOOTER //
// ./src/styles/video.js